export default {
    root: {
        paddingBottom: 0,
        '& *': { boxSizing: 'border-box' },
        '& [class*="Modal__header"]': {
            paddingBottom: 32,
            position: 'relative',
            '&::after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                height: 2,
                bottom: 16,
                left: -32,
                right: -32,
                background: 'linear-gradient(to right, #00d639, #00d6de, #9d60ff)',
            },
        },
    },
    avatar: {
        width: 30,
        height: 30,
    },
    chat: {
        padding: 0,
        height: '100%',
        '& [class*="InputWrapper__formControl"]': {
            width: '100%',
        },
    },
    footer: {
        flex: 1,
        marginLeft: -32,
        marginRight: -32,
        marginBottom: -16,
        paddingLeft: 32,
        paddingRight: 32,
        paddingBottom: 0,
    },
    titleContainer: {
        display: 'flex',
        flexFlow: 'row nowrap',
        width: 'calc(100% - 24px)',
        alignItems: 'center',
        gap: 16,
    },
    titleLogo: {
        flex: '0 0 40px',
        '& svg': {
            display: 'block',
        },
    },
    titleCopy: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        maxWidth: 'calc(100% - 56px - 24px)',
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
};
